import { ChangeDetectionStrategy, Component, effect, EffectRef, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { FormGroup, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SelectComponent, SubmitGroupComponent, TextComponent } from '@libs/form/components';
import { SelectInputModel, SubmitGroupItemModel, TextInputModel } from '@libs/form/models';
import { UserModel } from '@libs/account/models';
import { FirstNameInputData, LastNameInputData, SalutationInputData, SubmitGroupData } from './user-data.model';

@Component({
  selector: 'ui-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.scss'],
  imports: [
    SelectComponent,
    TextComponent,
    SubmitGroupComponent,
    ReactiveFormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDataComponent {
  private readonly syncUserEffect: EffectRef;

  public readonly user: InputSignal<UserModel | undefined> = input<UserModel | undefined>();
  public readonly submitResult: OutputEmitterRef<Partial<UserModel>> = output<Partial<UserModel>>();

  public dataSalutation: SelectInputModel = SalutationInputData;
  public dataFirstName: TextInputModel = FirstNameInputData;
  public dataLastName: TextInputModel = LastNameInputData;
  public dataSubmit: SubmitGroupItemModel = SubmitGroupData;

  public group: FormGroup = new UntypedFormGroup({
    [this.dataSalutation.name]: new UntypedFormControl(),
    [this.dataFirstName.name]: new UntypedFormControl(),
    [this.dataLastName.name]: new UntypedFormControl(),
  });

  public constructor() {
    this.syncUserEffect = effect(() => {
      const user: UserModel | undefined = this.user();

      if (!user) {
        this.group.reset();
      } else {
        this.group.setValue({
          salutation: user.salutation,
          givenName: user.givenName,
          lastName: user.lastName,
        });
      }
    });
  }

  public onSubmit(): void {
    if (this.group.valid) {
      this.submitResult.emit(this.group.value as Partial<UserModel>);
    }
  }
}
